module.exports = __webpack_public_path__ + "img/mind_skeleton_time_7.b273e6da.png";